module.exports = __webpack_public_path__ + "img/utilitylight_stopped.5394df10.svg";